/**
 * Pipeline page — entry point para el `/pipeline` route.
 * Wrapper sobre el PipelineAdvisor component.
 */

import { PipelineAdvisor } from '../components/PipelineAdvisor'

export function Pipeline() {
  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-bold">Pipeline</h1>
          <p className="text-eve-muted text-sm">
            ISK por hora del pipeline completo de mining → haul → refinery → sell,
            para los 16 ores estándar. Tu setup personal — se guarda en este
            navegador.
          </p>
        </div>
      </div>

      <PipelineAdvisor />
    </div>
  )
}
